<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        
        <b-button block v-b-toggle.privacy-section-6
        class="text-left fw-500 d-flex align-items-center justify-content-between">
            <div>
                <span class="box-numbering">06</span>
                <span>Retention of Data</span>    
            </div>
            <span 
                class="toggle-icon" 
                :class="{ active: isOpen }"
            >
                <span class="plus">+</span>
                <span class="cross">×</span>
            </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="privacy-section-6"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Retention of Data We retain your personal information only for as
            long as necessary to fulfil the purposes for which it was collected,
            or as required by law.
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "section-6",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
